import React from "react";
import { Search } from "lucide-react";
import { STATUS_OPTIONS } from "../../lib/quoteStatus";

export const DashboardFilters = ({
  statusFilter,
  onFilterChange,
  counts,
  search,
  onSearchChange,
}) => (
  <div className="flex flex-col lg:flex-row lg:items-center gap-4 mb-6">
    <div className="flex flex-wrap gap-2">
      {["all", ...STATUS_OPTIONS].map((s) => (
        <button
          key={s}
          data-testid={`filter-${s}`}
          onClick={() => onFilterChange(s)}
          className={`px-3 py-2 font-display uppercase text-[11px] tracking-[0.15em] border-2 border-navy transition-colors ${
            statusFilter === s
              ? "bg-navy text-white"
              : "bg-white text-navy hover:bg-navy/5"
          }`}
        >
          {s} <span className="ml-1 opacity-70">({counts[s] || 0})</span>
        </button>
      ))}
    </div>

    <div className="lg:ml-auto relative">
      <Search className="h-4 w-4 absolute left-3 top-1/2 -translate-y-1/2 text-navy/60" />
      <input
        data-testid="admin-search-input"
        value={search}
        onChange={(e) => onSearchChange(e.target.value)}
        placeholder="Search name, phone, email…"
        className="w-full lg:w-80 pl-9 pr-3 py-3 bg-white border-2 border-navy font-body text-sm outline-none focus:shadow-[4px_4px_0_0_#f5a623] focus:-translate-x-0.5 focus:-translate-y-0.5 transition-transform"
      />
    </div>
  </div>
);
